module.exports = __webpack_public_path__ + "img/plus-btn.85214341.svg";